import type { IResource } from '../ResourceCard';

const LONG_DESCRIPTION_MEDIA_SELECTOR = 'img, iframe, video, audio, embed, object, svg, canvas';

export const hasResourceLongDescriptionContent = (longDescription?: string) => {
  if (!longDescription?.trim()) return false;

  const container = document.createElement('div');
  container.innerHTML = longDescription;

  const textContent = (container.textContent || '').replace(/\u00a0/g, ' ').trim();

  return !!textContent || !!container.querySelector(LONG_DESCRIPTION_MEDIA_SELECTOR);
};

export const resourceLongDescriptionTitle = (
  resource?: Pick<IResource, 'type' | 'long_description'>
) => {
  const isCaseStudy = resource?.type?.name?.trim().toLowerCase() === 'case studies';

  if (isCaseStudy) return 'The Story';
  if (hasResourceLongDescriptionContent(resource?.long_description)) return 'Description';

  return null;
};
